import axios from 'axios'
import { AsyncJobResponse } from 'src/queries/asyncJobs/asyncJobs.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getAsyncJob = async (jobId: string): Promise<AsyncJobResponse> => {
  return getResponseData(
    axios.get<AsyncJobResponse>(
      `/asyncJobs/${jobId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
